import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../api.js';
import RichEditor from '../components/RichEditor.jsx';

export default function PostEditor({ kind }) {
  const { id } = useParams();
  const nav = useNavigate();
  const editing = Boolean(id);
  const [title, setTitle] = useState('');
  const [html, setHtml] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    if (editing) api.getPost(kind, id).then(p => { setTitle(p.title); setHtml(p.content_html); });
  }, [kind, id, editing]);

  const save = async () => {
    setErr('');
    try {
      if (editing) {
        await api.patchPost(kind, id, { title, content_html: html });
        nav('/' + kind + '/' + id);
      } else {
        const r = await api.createPost(kind, { title, content_html: html });
        nav('/' + kind + '/' + r.id);
      }
    } catch (e) { setErr(e.message); }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <h1 className="text-xl font-bold text-medical-800 mb-3">{editing ? '글 수정' : '새 글 작성'}</h1>
      <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="제목"
        className="w-full mb-3 px-3 py-2 border border-medical-200 rounded-md text-lg" />
      <RichEditor value={html} onChange={setHtml} />
      {err && <div className="text-sm text-red-600 mt-2">{err}</div>}
      <div className="mt-4 flex gap-2">
        <button onClick={save} className="bg-medical-600 hover:bg-medical-700 text-white font-semibold px-4 py-2 rounded-md">저장</button>
        <button onClick={() => nav(-1)} className="bg-white border border-medical-200 text-medical-700 px-4 py-2 rounded-md">취소</button>
      </div>
    </div>
  );
}
